import {ResponseData} from "@/utils/response";
import http from "../utils/http-common";
import {LoginInput, SignUpInput, ForgotInput, ResetInput, ChangePassInput} from "../utils/types";

class AuthService {
    async createUser(data: SignUpInput) {
        return http.post<ResponseData>("/auth/create", data);
    }
    async changePassword(data: ChangePassInput) {
        return http.post<ResponseData>("/auth/password", data);
    }

    async login(data: LoginInput) {
        return http.post<ResponseData>(`/auth/login`, data);
    }
    async forgotPassword(data: ForgotInput) {
        return http.post<ResponseData>(`/auth/forgot`, data);
    }
    async resetPassword(data: ResetInput) {
        return http.post<ResponseData>(`/auth/reset-password`, data);
    }

    // `config` cho phép caller tự hiển thị lỗi (skipErrorNotification) khi có retry
    async getGoogleUrl(config = {}) {
        return http.get<ResponseData>('/auth/google/url', config);
    }

    async googleCallback(data: { code: string; redirect_uri: string }) {
        return http.post<ResponseData>('/auth/google/callback', data);
    }
}

export default new AuthService();
